import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {LoaderDialogComponent} from "../ui/loader-dialog/loader-dialog.component";

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private dialogRef: MatDialogRef<LoaderDialogComponent> | null = null;

  constructor(private dialog: MatDialog) {}

  // Método para mostrar el loader
  show(): void {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(LoaderDialogComponent, {
        disableClose: true, // Deshabilita el cierre manual
        panelClass: 'transparent-dialog', // Estilo personalizado
      });
    }
  }

  // Método para ocultar el loader
  hide(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
